var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"swiper",rawName:"v-swiper:AccSlider",value:(_vm.settings),expression:"settings",arg:"AccSlider"}]},[_c('div',{staticClass:"swiper-wrapper",staticStyle:{"transition":"linear"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }